(function () {
  var KN_DEBUG = false;

  function knDebug() {
    if (!KN_DEBUG || typeof console === "undefined") return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[KN-PDP-PRICE-QTY]");
    console.log.apply(console, args);
  }

  function toNumber(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 1 : Math.max(1, n);
  }

  function toNonNegativeInt(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : Math.max(0, n);
  }

  function getQuantity(productInformation) {
    if (!productInformation) return 1;

    // Visible qty input is the source of truth after cart:added reset.
    var visibleQuantity = productInformation.querySelector('quantity-input input[name="quantity-js"]');
    if (visibleQuantity && visibleQuantity.value) return toNumber(visibleQuantity.value);

    var hiddenQuantity = productInformation.querySelector('product-form input[name="quantity"]');
    if (hiddenQuantity && hiddenQuantity.value) return toNumber(hiddenQuantity.value);

    return 1;
  }

  function syncHiddenQuantity(productInformation, quantity) {
    if (!productInformation) return;
    var hiddenQuantity = productInformation.querySelector('product-form input[name="quantity"]');
    if (hiddenQuantity) hiddenQuantity.value = String(toNumber(quantity));
  }

  function detectFormat(numberText) {
    var trimmed = (numberText || "").trim();
    var commas = (trimmed.match(/,/g) || []).length;
    var dots = (trimmed.match(/\./g) || []).length;
    var hasComma = commas > 0;
    var hasDot = dots > 0;
    var decimalSep = "";
    var thousandSep = "";
    var decimalPlaces = 0;

    if (hasComma && hasDot) {
      decimalSep = trimmed.lastIndexOf(",") > trimmed.lastIndexOf(".") ? "," : ".";
      thousandSep = decimalSep === "," ? "." : ",";
    } else if (hasComma || hasDot) {
      var sep = hasComma ? "," : ".";
      var last = trimmed.lastIndexOf(sep);
      var decimals = trimmed.length - last - 1;

      if (decimals > 0 && decimals <= 2) {
        decimalSep = sep;
      } else {
        thousandSep = sep;
      }
    }

    if (decimalSep) {
      var split = trimmed.split(decimalSep);
      decimalPlaces = split[1] ? split[1].length : 0;
    }

    return {
      decimalSep: decimalSep,
      thousandSep: thousandSep,
      decimalPlaces: decimalPlaces
    };
  }

  function parseMoneyText(text) {
    var source = (text || "").trim();
    if (!source) return null;

    var match = source.match(/^(.*?)(-?\d[\d.,\s]*)(.*)$/);
    if (!match) return null;

    var prefix = match[1] || "";
    var numberText = (match[2] || "").trim();
    var suffix = match[3] || "";
    var format = detectFormat(numberText);
    var normalized = numberText.replace(/\s/g, "");

    if (format.thousandSep) {
      var ts = new RegExp("\\" + format.thousandSep, "g");
      normalized = normalized.replace(ts, "");
    }

    if (format.decimalSep && format.decimalSep !== ".") {
      var ds = new RegExp("\\" + format.decimalSep, "g");
      normalized = normalized.replace(ds, ".");
    }

    var amount = Number(normalized);
    if (isNaN(amount)) return null;

    return {
      amount: amount,
      prefix: prefix,
      suffix: suffix,
      format: format
    };
  }

  function formatMoneyAmount(amount, meta) {
    if (!meta || !meta.format) return String(amount);

    var format = meta.format;
    var fixed = Number(amount).toFixed(format.decimalPlaces);
    var parts = fixed.split(".");
    var integerPart = parts[0];
    var decimalPart = parts[1] || "";
    var sign = "";

    if (integerPart.charAt(0) === "-") {
      sign = "-";
      integerPart = integerPart.slice(1);
    }

    if (format.thousandSep) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, format.thousandSep);
    }

    var result = sign + integerPart;
    if (format.decimalPlaces > 0) {
      result += (format.decimalSep || ".") + decimalPart;
    }

    return (meta.prefix || "") + result + (meta.suffix || "");
  }

  function setBaseAmount(el) {
    if (!el) return;
    if (el.dataset.knBaseAmount) return;

    var parsed = parseMoneyText(el.textContent);
    if (!parsed) return;

    el.dataset.knBaseAmount = String(parsed.amount);
    el.dataset.knMoneyPrefix = parsed.prefix || "";
    el.dataset.knMoneySuffix = parsed.suffix || "";
    el.dataset.knMoneyDecimalSep = parsed.format.decimalSep || "";
    el.dataset.knMoneyThousandSep = parsed.format.thousandSep || "";
    el.dataset.knMoneyDecimalPlaces = String(parsed.format.decimalPlaces || 0);
  }

  function getMetaFromDataset(el) {
    if (!el || !el.dataset.knBaseAmount) return null;

    return {
      amount: Number(el.dataset.knBaseAmount),
      prefix: el.dataset.knMoneyPrefix || "",
      suffix: el.dataset.knMoneySuffix || "",
      format: {
        decimalSep: el.dataset.knMoneyDecimalSep || "",
        thousandSep: el.dataset.knMoneyThousandSep || "",
        decimalPlaces: toNonNegativeInt(el.dataset.knMoneyDecimalPlaces)
      }
    };
  }

  function applyMoneyMultiplier(el, quantity) {
    setBaseAmount(el);
    var meta = getMetaFromDataset(el);
    if (!meta || isNaN(meta.amount)) return;

    var total = meta.amount * quantity;
    el.textContent = formatMoneyAmount(total, meta);
  }

  function applyOptionMultiplier(optionEl, quantity) {
    if (!optionEl) return;

    if (!optionEl.dataset.knBaseOptionText) {
      optionEl.dataset.knBaseOptionText = optionEl.textContent || "";
    }

    var baseText = optionEl.dataset.knBaseOptionText;
    var match = baseText.match(/\(([^()]*)\)/);
    if (!match) return;

    var parsed = parseMoneyText(match[1]);
    if (!parsed) return;

    var multiplied = formatMoneyAmount(parsed.amount * quantity, parsed);
    optionEl.textContent = baseText.replace(match[1], multiplied);
  }

  function updatePriceBlock(productInformation, quantity) {
    if (!productInformation) return;

    var mainPriceMoney = productInformation.querySelector('[data-product-price] .money');
    var comparePriceMoney = productInformation.querySelector('#ComparePrice .money');

    if (mainPriceMoney) applyMoneyMultiplier(mainPriceMoney, quantity);
    if (comparePriceMoney) applyMoneyMultiplier(comparePriceMoney, quantity);
  }

  function updateRecurpayBlock(productInformation, quantity) {
    if (!productInformation) return;

    var recurpayRoot = productInformation.querySelector(".recurpay-pdp-widget");
    if (!recurpayRoot) return;

    var moneyEls = recurpayRoot.querySelectorAll(".money");
    for (var i = 0; i < moneyEls.length; i += 1) {
      applyMoneyMultiplier(moneyEls[i], quantity);
    }

    var options = recurpayRoot.querySelectorAll("select.recurpay__frequency option");
    for (var j = 0; j < options.length; j += 1) {
      applyOptionMultiplier(options[j], quantity);
    }
  }

  function addBusinessDays(startDate, businessDaysToAdd) {
    var date = new Date(startDate.getTime());
    var daysAdded = 0;

    while (daysAdded < businessDaysToAdd) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) {
        daysAdded += 1;
      }
    }

    return date;
  }

  function formatUKDate(date) {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      day: "numeric",
      month: "short",
    }).format(date);
  }

  function updateShippingNoteBlock(productInformation) {
    if (!productInformation) return;

    var notes = productInformation.querySelectorAll("[data-kn-shipping-note]");
    if (!notes.length) return;

    for (var i = 0; i < notes.length; i += 1) {
      var note = notes[i];
      var template = note.getAttribute("data-kn-template") || note.textContent || "";
      var deliveryDays = toNumber(note.getAttribute("data-kn-delivery-business-days") || "5");
      var estimatedDate = addBusinessDays(new Date(), deliveryDays);
      var dateText = formatUKDate(estimatedDate);
      note.textContent = template.replace(/\[\[date\]\]/g, dateText);
      note.classList.remove("kn-shipping-note--pending");
    }
  }

  function updateAllForProduct(productInformation, sourceEvent, forcedQuantity) {
    if (!productInformation) return;
    var quantity = typeof forcedQuantity === "number" ? toNumber(forcedQuantity) : getQuantity(productInformation);
    syncHiddenQuantity(productInformation, quantity);
    updatePriceBlock(productInformation, quantity);
    updateRecurpayBlock(productInformation, quantity);
    updateShippingNoteBlock(productInformation);
    knDebug("Updated totals on event", {
      sourceEvent: sourceEvent || "unknown",
      sectionId: productInformation.getAttribute("data-section-id"),
      quantity: quantity
    });
  }

  function isPDP() {
    return !!(document.body && document.body.className.indexOf("template-product") > -1);
  }

  function getProductInformationBySection(sectionId) {
    if (sectionId) {
      return document.querySelector('product-information[data-section-id="' + String(sectionId) + '"]');
    }
    return document.querySelector("product-information");
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (!isPDP()) {
      knDebug("Skipped: non-PDP template");
      return;
    }

    knDebug("Init on PDP: listening to theme events only");

    var allProductInformation = document.querySelectorAll("product-information");
    for (var i = 0; i < allProductInformation.length; i += 1) {
      updateShippingNoteBlock(allProductInformation[i]);
    }

    if (window.eventBus && typeof window.eventBus.on === "function") {
      window.eventBus.on("qty:change", function (payload) {
        var sectionId = payload && payload.sectionId ? payload.sectionId : "";
        var target = getProductInformationBySection(sectionId);
        if (target) updateAllForProduct(target, "qty:change");
      });

      window.eventBus.on("variant:updated", function (payload) {
        var sectionId = payload && payload.sectionId ? payload.sectionId : "";
        var target = getProductInformationBySection(sectionId);
        if (target) {
          // Variant updates replace DOM chunks; capture new base values and re-apply quantity totals.
          setTimeout(function () {
            updateAllForProduct(target, "variant:updated");
          }, 20);
        }
      });

      window.eventBus.on("cart:added", function (payload) {
        var sectionId = payload && payload.sectionId ? payload.sectionId : "";
        var target = getProductInformationBySection(sectionId);
        if (!target) return;

        // Quantity input resets to 1 on cart add; enforce synced reset before pricing update.
        setTimeout(function () {
          syncHiddenQuantity(target, 1);
          updateAllForProduct(target, "cart:added", 1);
        }, 30);
      });
    } else {
      knDebug("Skipped: eventBus unavailable");
    }
  });
})();

(function () {
  var KN_MOBILE_NAV_DEBUG = false;

  function knMobileNavDebug() {
    if (!KN_MOBILE_NAV_DEBUG || typeof console === "undefined") return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[KN-MOBILE-NAV-HASH-LINK]");
    console.log.apply(console, args);
  }

  function isHashOnlyLink(linkEl) {
    if (!linkEl || typeof linkEl.getAttribute !== "function") return false;
    var href = (linkEl.getAttribute("href") || "").trim();
    return href === "#";
  }

  function handleHashSublistLinkClick(evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== "function") return;

    var linkEl = target.closest(".mobile-nav__has-sublist > .mobile-nav__link");
    if (!linkEl || !isHashOnlyLink(linkEl)) return;

    var hasSublist = linkEl.closest(".mobile-nav__has-sublist");
    if (!hasSublist) return;

    var toggleEl = hasSublist.querySelector(".mobile-nav__toggle");
    if (!toggleEl) {
      knMobileNavDebug("No matching .mobile-nav__toggle found", linkEl);
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    if (typeof evt.stopImmediatePropagation === "function") {
      evt.stopImmediatePropagation();
    }

    toggleEl.click();
    knMobileNavDebug("Forwarded hash link click to toggle", {
      text: (linkEl.textContent || "").trim()
    });
  }
  
  function handleHeaderHashAnchorClick(evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== "function") return;

    var linkEl = target.closest(".header-section a");
    if (!linkEl || !isHashOnlyLink(linkEl)) return;

    evt.preventDefault();
    knMobileNavDebug("Prevented default # link navigation", {
      text: (linkEl.textContent || "").trim()
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", handleHashSublistLinkClick, true);
    document.addEventListener("click", handleHeaderHashAnchorClick, true);
    knMobileNavDebug("Initialized hash-link submenu behavior");
  });
})();

(function () {
  function initVerticalMenuHoverFix() {
    var parents = document.querySelectorAll(".kn-vertical-menu-parent");
    if (!parents.length) return;

    parents.forEach(function (parent) {
      var dropdown = parent.querySelector(".kn-vertical-menu-dropdown");
      if (!dropdown) return;

      parent.addEventListener("mouseenter", function () {
        parent.classList.add("nav-hover");
      }, true);

      dropdown.addEventListener("mouseenter", function () {
        parent.classList.add("nav-hover");
      }, true);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVerticalMenuHoverFix);
  } else {
    initVerticalMenuHoverFix();
  }

  document.addEventListener("shopify:section:load", initVerticalMenuHoverFix);
})();

// ===== RecurPay inline quantity selectors =====
(function () {
  var KN_IQB_DEBUG = false;

  function debug() {
    if (!KN_IQB_DEBUG || typeof console === "undefined") return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[KN-INLINE-QTY]");
    console.log.apply(console, args);
  }

  var recurpayObservers = [];

  function getAllInlineQtyProductInfos() {
    return Array.prototype.slice.call(
      document.querySelectorAll("product-information[data-section-id]")
    ).filter(function (el) {
      return el.querySelector("[data-kn-inline-qty]");
    });
  }

  function isEnabled(productInfo) {
    return !!(productInfo && productInfo.querySelector("[data-kn-inline-qty]"));
  }

  function getRealQtyInput(productInfo) {
    // The real one is the quantity-input that is NOT a clone
    var all = productInfo.querySelectorAll("quantity-input:not(.kn-qty-clone)");
    return all[0] || null;
  }

  function makeClone(realQtyInput) {
    var clone = realQtyInput.cloneNode(true);
    clone.classList.add("kn-qty-clone");
    // Remove id/for to avoid duplicate IDs — label is hidden via CSS anyway
    var input = clone.querySelector("input");
    if (input) input.removeAttribute("id");
    var label = clone.querySelector("label");
    if (label) label.removeAttribute("for");
    return clone;
  }

  function insertBeforeATC(productInfo, realQtyInput) {
    var atcButton = productInfo.querySelector(".product--add-to-cart-button");
    if (!atcButton) {
      debug("ATC: button not found");
      return;
    }
    // Skip if already wrapped
    if (atcButton.parentNode.classList.contains("kn-atc-qty-row")) return;

    var clone = makeClone(realQtyInput);
    // Create a dedicated row wrapper placed at the ATC button's current position
    var row = document.createElement("div");
    row.className = "kn-atc-qty-row";
    atcButton.parentNode.insertBefore(row, atcButton);
    row.appendChild(clone);
    row.appendChild(atcButton);
    debug("Created kn-atc-qty-row wrapping clone + ATC button");
  }

  function insertInsideRecurpay(productInfo, realQtyInput) {
    var action = productInfo.querySelector(".recurpay__action");
    if (!action) return false;

    // Skip if already inserted
    if (action.querySelector(".kn-qty-clone")) return true;

    var clone = makeClone(realQtyInput);
    // Insert before the Subscribe button inside .recurpay__action
    var subscribeBtn = action.querySelector("button");
    if (subscribeBtn) {
      action.insertBefore(clone, subscribeBtn);
    } else {
      action.insertBefore(clone, action.firstChild);
    }
    action.classList.add("kn-inline-qty-active");
    debug("Inserted qty clone inside .recurpay__action");
    return true;
  }

  function firePriceSync(productInfo) {
    // Re-emit qty:change AFTER the original is synced so the price IIFE
    // reads the correct (freshly-synced) value instead of the stale original.
    var sectionId = productInfo.getAttribute("data-section-id") || "";
    if (window.eventBus && typeof window.eventBus.emit === "function") {
      window.eventBus.emit("qty:change", { sectionId: sectionId });
      debug("Re-emitted qty:change for price sync, sectionId:", sectionId);
    }
  }

  function syncAllQty(productInfo, value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 1) n = 1;
    var inputs = productInfo.querySelectorAll('quantity-input input[name="quantity-js"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== String(n)) inputs[i].value = String(n);
    }
    var hidden = productInfo.querySelector('product-form input[name="quantity"]');
    if (hidden) hidden.value = String(n);
    debug("Synced qty to", n);
    // Trigger price update now that the original input has the correct value
    firePriceSync(productInfo);
  }

  function setupSync(productInfo) {
    if (productInfo.dataset.knInlineQtySync === "1") return;
    productInfo.dataset.knInlineQtySync = "1";

    // Delegated: catches +/- clicks on original and all clones.
    // The web component updates input.value synchronously before bubbling here,
    // so no setTimeout needed — we read the correct value immediately.
    productInfo.addEventListener("click", function (e) {
      var btn = e.target.closest
        ? e.target.closest(".js-qty__adjust")
        : null;
      if (!btn) return;
      var qtyEl = btn.closest("quantity-input");
      if (!qtyEl) return;
      var input = qtyEl.querySelector('input[name="quantity-js"]');
      if (input) syncAllQty(productInfo, input.value);
    });

    // Direct typing into any qty input
    productInfo.addEventListener("change", function (e) {
      if (!e.target || e.target.name !== "quantity-js") return;
      syncAllQty(productInfo, e.target.value);
    });

    debug("Sync listeners attached");
  }

  function watchForRecurpay(productInfo, realQtyInput) {
    if (productInfo.knRecurpayObserver) return;
    var observer = new MutationObserver(function () {
      var done = insertInsideRecurpay(productInfo, realQtyInput);
      if (done) {
        observer.disconnect();
        productInfo.knRecurpayObserver = null;
        var i = recurpayObservers.indexOf(observer);
        if (i !== -1) recurpayObservers.splice(i, 1);
        debug("RecurPay observer disconnected");
      }
    });
    productInfo.knRecurpayObserver = observer;
    recurpayObservers.push(observer);
    observer.observe(productInfo, { childList: true, subtree: true });
    debug("Watching for RecurPay widget...");
  }

  function initOne(productInfo) {
    if (!productInfo || !isEnabled(productInfo)) return;

    var realQtyInput = getRealQtyInput(productInfo);
    if (!realQtyInput) {
      debug("No quantity-input found");
      return;
    }

    insertBeforeATC(productInfo, realQtyInput);

    var recurpayDone = insertInsideRecurpay(productInfo, realQtyInput);
    if (!recurpayDone) {
      watchForRecurpay(productInfo, realQtyInput);
    }

    setupSync(productInfo);
    debug("Init complete for section", productInfo.getAttribute("data-section-id"));
  }

  function init() {
    var list = getAllInlineQtyProductInfos();
    if (!list.length) {
      debug("Inline qty not enabled on any product-information");
      return;
    }
    list.forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", init);

  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll("product-information[data-section-id]").forEach(function (el) {
      delete el.dataset.knInlineQtySync;
      if (el.knRecurpayObserver) {
        el.knRecurpayObserver.disconnect();
        el.knRecurpayObserver = null;
      }
    });
    recurpayObservers.forEach(function (o) {
      try {
        o.disconnect();
      } catch (e) {}
    });
    recurpayObservers = [];
    init();
  });
})();